module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\"><i ng-if=\"$ctrl.icon\" class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i> {{$ctrl.title}}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <dl class=\"dl-horizontal\">\n    <dt ng-repeat-start=\"field in $ctrl.fields\">{{field.name}}</dt>\n    <dd ng-repeat-end=\"\">{{field.data}}</dd>\n  </dl>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/~ap/components/detail-list-modal/detail-list-modal.component.html
// module id = 980
// module chunks = 0